import IndieStaticSelect from "components/forms/IndieStaticSelect";
import TableSelectFilter from "components/tables/TableSelectFilter";
import { TariffsContext } from "contexts/tariffs/TariffsContext";
import useAuth from "hooks/useAuth";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const BusinessTypeSelect = (props) => {

    const { t } = useTranslation();
    const { hasPermissionGroup } = useAuth();
    const { setBusinessType } = useContext(TariffsContext);
    const options = [];
    if (hasPermissionGroup(["INDIE_ADMIN", "ENERGY_AGENT_AGGRTN_USER"])) {
        options.push({ value: "aggregation", label: t("label.businessType.aggregation") });
    }

    if (hasPermissionGroup(["INDIE_ADMIN", "ENERGY_AGENT_EGAC_USER"])) {
        options.push({ value: "communities", label: t("label.businessType.communities") });
    }

    return (
        <IndieStaticSelect label={t("label.form.businessType")} options={options} {...props} sx={{ width: 250 }} onChange={(e) => setBusinessType(e.target.value)} />
    )
};

export const BusinessTypeSelectFilter = (params) => {
    const { t } = useTranslation();
    const { hasPermissionGroup } = useAuth();

    const optionsLoader = () => {
        return new Promise((resolve, reject) => {
            const options = [];
            if (hasPermissionGroup(["INDIE_ADMIN", "ENERGY_AGENT_AGGRTN_USER"])) {
                options.push({ value: "aggregation", label: t("label.businessType.aggregation") });
            }

            if (hasPermissionGroup(["INDIE_ADMIN", "ENERGY_AGENT_EGAC_USER"])) {
                options.push({ value: "communities", label: t("label.businessType.communities") });
            }

            resolve(options)
        });
    }

    return (
        <TableSelectFilter optionsLoader={optionsLoader} {...params}  />
    )
}

export default BusinessTypeSelect;